// @ts-check
import React from "react"
import { clsx } from "../../../../../utils/strings.utils"

/**
 * @typedef {object} EmptyStateProps
 * @property {string} [iconClassName]
 * @property {import("react").ReactNode} [children]
 * @property {string} [className]
 */

/**
 * @param {EmptyStateProps} props
 */
export default function EmptyState({
  iconClassName = "pi pi-sitemap",
  children,
  className,
}) {
  return (
    <div
      className={clsx("estimation-agent-quick-v3__body--empty", className)}
    >
      <i className={iconClassName}></i>
      {children}
    </div>
  )
}
